import { createSelector } from 'reselect';
import { buildOrderObject } from '../../helpers/order';

const getOrders = (state) => state.businessApp.orderCenter.orders;

export const getActiveOrders = createSelector(
    [getOrders],
    (orders) => {
        return orders.map(buildOrderObject);
    }
);
